export default function SignupTable({
  records,
  filteredRecords,
  searchTerm,
  setSearchTerm,
  serviceFilter,
  setServiceFilter,
  statusFilter,
  setStatusFilter,
  handleStatusChange,
  setSelectedSignup,
}) {
  return (
    <>
   
              <div className="bg-white rounded-3xl border border-sage-100 shadow-soft p-5 mb-6">
  <div className="grid md:grid-cols-3 gap-4">

    <input
      type="text"
      value={searchTerm}
      onChange={(e) => setSearchTerm(e.target.value)}
      placeholder="Search name, phone or email..."
      className="w-full border border-sage-100 rounded-2xl px-4 py-3 outline-none focus:border-sage-600"
    />

    <select
      value={serviceFilter}
      onChange={(e) => setServiceFilter(e.target.value)}
      className="w-full border border-sage-100 rounded-2xl px-4 py-3 bg-white outline-none focus:border-sage-600"
    >
      <option value="All">All Services</option>
      <option value="babysitting">Babysitting</option>
      <option value="elder-care">Elder Care</option>
      <option value="therapy">Therapy</option>
      <option value="postpartum">Postpartum</option>
    </select>

    <select
      value={statusFilter}
      onChange={(e) => setStatusFilter(e.target.value)}
      className="w-full border border-sage-100 rounded-2xl px-4 py-3 bg-white outline-none focus:border-sage-600"
    >
      <option value="All">All Statuses</option>
      <option value="New">New</option>
      <option value="Contacted">Contacted</option>
      <option value="In Progress">In Progress</option>
      <option value="Converted">Converted</option>
      <option value="Closed">Closed</option>
    </select>

  </div>
</div>
              <table className="w-full text-left">
                <thead className="bg-sage-50">
                  <tr>
                    <th className="px-6 py-4">Name</th>
                    <th className="px-6 py-4">Phone</th>
                    <th className="px-6 py-4">Service</th>
                    <th className="px-6 py-4">City</th>
                    <th className="px-6 py-4">Date</th>
                    <th className="px-6 py-4">Status</th>
                    <th className="px-6 py-4">Actions</th>
                  </tr>
                </thead>

                <tbody>
                  {filteredRecords.map((signup) => (
                    <tr
                      key={signup.id}
                      className="border-t border-sage-100"
                    >
                      <td className="px-6 py-4">
                        {signup.name || "-"}
                      </td>

                      <td className="px-6 py-4">
                        {signup.phone || "-"}
                      </td>

                      <td className="px-6 py-4 capitalize">
                        {signup.service || "-"}
                      </td>

                      <td className="px-6 py-4">
                        {signup.city || "-"}
                      </td>

                      <td className="px-6 py-4">
                        {signup.createdAt?.toDate
                          ? signup.createdAt
                              .toDate()
                              .toLocaleDateString()
                          : "-"}
                      </td>
                      <td className="px-6 py-4">
  <select
    value={signup.status || "New"}
    onChange={(e) =>
      handleStatusChange(signup.id, e.target.value)
    }
    className="border border-sage-100 rounded-xl px-3 py-2 text-sm bg-white outline-none focus:border-sage-600"
  >
    <option value="New">New</option>
    <option value="Contacted">Contacted</option>
    <option value="In Progress">In Progress</option>
    <option value="Converted">Converted</option>
    <option value="Closed">Closed</option>
  </select>
</td>
                      <td className="px-6 py-4">
  <button
    type="button"
    onClick={() => {
  console.log("Clicked", signup);
  setSelectedSignup(signup);
}}
    className="text-sage-700 font-medium hover:underline"
  >
    View Details
  </button>
</td>
                    </tr>
                  ))}
                </tbody>
              </table></>
)}
 